import { render } from "./FileTypesView.vue?vue&type=template&id=32ff8f64&scoped=true"
import script from "./FileTypesView.vue?vue&type=script&lang=js"
export * from "./FileTypesView.vue?vue&type=script&lang=js"

import "./FileTypesView.vue?vue&type=style&index=0&id=32ff8f64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ff8f64"]])

export default __exports__